var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-modal',{ref:"modal",attrs:{"type":"error","modal-error":""},on:{"hide":_vm.onHide}},_vm._l((_vm.errors),function(error,index){return _c('div',{key:index,staticClass:"error-text"},[_vm._v("\n    "+_vm._s(error)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }